export const appLocaleTexts = {
  title: '清掃管理システム',
}
